
import React from 'react';

// import NonFSIndex from '../../components/NonFSIndex';

export default function SenseIndex() {
  // return (
  //   <NonFSIndex
  //     data_type="sense"
  //   />
  // );
  return <></>
}
